import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import { DASHBOARD_PATH } from '../../utils/constants';

export default class Topbar extends PureComponent {
  componentDidMount() {
    const { name, email } = this.props;
    const deskWidget = document.querySelector('.a-desk-widget-email');
    let link = deskWidget.href;
    link = link.slice(0, link.indexOf('&') + 1);
    link += 'interaction[email]=' + encodeURIComponent(email);
    link += '&interaction[name]=' + encodeURIComponent(name);
    link += '&email[subject]=' + encodeURIComponent('Developer Website');
    deskWidget.href = link;
  }

  render() {
    return (
      <div className="topbar">
        <div className="topbar__wrapper">
          <TopbarSidebarButton />
          <Link className="topbar__logo" to={DASHBOARD_PATH} />
          <div className="topbar__right">
            <TopbarProfile {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/topbar/Topbar.js